import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { FormatIndianNumber } from "../utiles/FormatIndianNumber";
import TableLayout from "./TableLayout";
import useLocale from "../locales";
const LtvTable = ({showTable, historyData,
  shouldGenerateReport,
  setShouldGenerateReport,calcDone}) => {
    const {textData} = useLocale();
    const [reportData , setReportData] = useState([]);
    const {propertyValue,timePeriod,interestRate,propertyType,employmentType , monthlyEmi} = useSelector((state) => state.ltvCalculator);
  
    useEffect(()=>{
        if
        (historyData){
            generateReportFromHistory();
        }
        
    },[ showTable, propertyValue , timePeriod , interestRate, propertyType, employmentType, monthlyEmi, historyData]);

  useEffect(() => {
    if (shouldGenerateReport) {
      generateReportData();
      setShouldGenerateReport(false);
    }else if (!calcDone) {
    setReportData([]); 
  }
  generateReportFromHistory();
}, [shouldGenerateReport, calcDone, historyData]);

    const generateReportFromHistory = () => {
        if(!Array.isArray(historyData) || historyData.length === 0){
            return;
        }
        
        const ltvData = historyData[0];
        
        const historyPropertyType = ltvData.propertyType;
        const historyEmploymentType = ltvData.employmentType;
        const historyTimePeriod = ltvData.tenure; 
        
        let ltvRatio = 0.75;
        if (historyPropertyType === "residential") {
            ltvRatio = historyEmploymentType === "salaried" ? 0.75 : 0.70;
        } else {
            ltvRatio = historyEmploymentType === "salaried" ? 0.70 : 0.65;
        }
        
        const loanAmount = (ltvData.totalInvestment * ltvRatio);
        const monthlyInterestRate = (ltvData.interesttRate);
        const calculatedEMI = (ltvData.emi);
        
        let balance = loanAmount;
        let totalInterestPaid = 0;
        const yearlyData = [];
        
        // Use history time period instead of Redux state
        for (let year = 1; year <= historyTimePeriod; year++) {
            let yearlyInterest = 0;
            let yearlyPrincipal = 0;
            
            for (let month = 1; month <= 12; month++) {
                if (balance <= 0) break;
                
                const interestPayment = balance * monthlyInterestRate;
                const principalPayment = calculatedEMI - interestPayment;
                
                yearlyInterest += interestPayment;
                yearlyPrincipal += principalPayment;
                balance -= principalPayment;
                if (balance < 0) balance = 0;
            }
            
            totalInterestPaid = yearlyInterest;
            
            yearlyData.push({
                year: year,
                monthlyPayment: calculatedEMI,
                intrestPaid: totalInterestPaid,
                principlePaid: yearlyPrincipal,
                remaingBalance: balance > 0 ? balance : 0
            });
        }
        
        setReportData(yearlyData);
    };

    const generateReportData = () => {
        // Calculate loan amount based on LTV ratio (typically 75-90% of property value)
        // For this example, I'll assume max LTV ratios:
        // - 90% for salaried individuals
        // - 75% for self-employed individuals
        let ltvRatio=0.75
        if (propertyType === "residential") {
            ltvRatio = employmentType === "salaried" ? 0.75 : 0.70;
          } else {
            ltvRatio = employmentType === "salaried" ? 0.70 : 0.65;
          }
        // const ltvRatio = employmentType === "salaried" ? 0.70 : 0.70;
        const loanAmount = propertyValue * ltvRatio;
        
        // Convert annual interest rate to monthly and time period to months
        const monthlyInterestRate = interestRate / 100 / 12;
        const totalMonths = timePeriod * 12;
        
        // Calculate EMI if not provided (though in your case it seems to be provided)
        const calculatedEMI = monthlyEmi || 
            (loanAmount * monthlyInterestRate * Math.pow(1 + monthlyInterestRate, totalMonths)) / 
            (Math.pow(1 + monthlyInterestRate, totalMonths) - 1);
        
        let balance = loanAmount;
        let totalInterestPaid = 0;
        const yearlyData = [];
        
        // Generate data for each year
        for (let year = 1; year <= timePeriod; year++) {
            let yearlyInterest = 0;
            let yearlyPrincipal = 0;
            
            // Calculate for each month in the year
            for (let month = 1; month <= 12; month++) {
                if (balance <= 0) break;
                
                const interestPayment = balance * monthlyInterestRate;
                const principalPayment = calculatedEMI - interestPayment;
                
                yearlyInterest += interestPayment;
                yearlyPrincipal += principalPayment;
                balance -= principalPayment;
                if (balance < 0) balance = 0;
            }
            
            totalInterestPaid = yearlyInterest;
            
            yearlyData.push({
                year: year,
                monthlyPayment: calculatedEMI , // Total yearly payment
                intrestPaid: totalInterestPaid,
                principlePaid: yearlyPrincipal,
                remaingBalance: balance > 0 ? balance : 0
            });
        }
        
        setReportData(yearlyData);
    };
    

     const columns=[
            { key: 'year', label: textData.tableLabels.year, format: (value) => value },
        {key: 'monthlyPayment' , label:`${textData.tableLabels.monthlyPayment} (${textData.currency})` ,format: (value) => `${FormatIndianNumber(Math.round(value))}` },
        {key: 'intrestPaid', label: `${textData.tableLabels.totalInterestPaid} (${textData.currency})`,format: (value) => `${FormatIndianNumber(Math.round(value))}` },
        {key: 'principlePaid', label: `${textData.tableLabels.principleRepaid} (${textData.currency})`,format: (value) => `${FormatIndianNumber(Math.round(value))}` },
        {key: 'remaingBalance', label: `${textData.tableLabels.remainingLoan} (${textData.currency})`,format: (value) => `${FormatIndianNumber(Math.round(value))}` }
         
     ];
    return (
        <TableLayout
        showTable={showTable}
        title={`${textData.filterDropDown.loanToValueCalc} ${textData.report}`}
      data={reportData}
        columns={columns}
        analyticsEventName="download_pl_report"
        reportTitle={textData.reportTitle.ltvReport}
        fileName="Ltv_ratio_detail"   
        />
  )
}

export default LtvTable
